import type { Condition, Configuration } from '@repo/api-gw-sdk';
import { AuditLogsApi, ListAuditLogsApi } from '@repo/api-gw-sdk';
import type { ColumnSort, PaginationState } from '@tanstack/react-table';

import type { HttpClient } from './httpClient';

const baseUrl = '/auditlogs';

export const auditLogs = (httpClient: HttpClient, config: Configuration) => {
  const listAuditLogsApi = new ListAuditLogsApi(config);
  const auditLogsApi = new AuditLogsApi(config);

  return {
    useList: (
      pagination: PaginationState,
      sorting: ColumnSort,
      columnFilters: Condition | undefined
    ) => {
      return httpClient.execute(
        listAuditLogsApi.listAuditLogsOld.bind(listAuditLogsApi),
        baseUrl,
        '',
        pagination.pageIndex,
        pagination.pageSize,
        `${sorting.id}:${sorting.desc ? 'desc' : 'asc'}`,
        { filter: columnFilters }
      );
    },
    download: (columnFilters: Condition | undefined, columns?: string) => {
      return auditLogsApi.auditLogsDownload(columns, { filter: columnFilters });
    },
  };
};
